export const BoxTitle = ({ title, aside }: { title: string; aside?: React.ReactNode }) => {
  return (
    <div className="border-gray-2 flex w-full items-center justify-between border-b p-4">
      <p className="text-base font-semibold">{title}</p>
      {aside}
    </div>
  );
};
